import React, { FC } from 'react';
import { ReactComponent as GooglePlayAppLogo } from '../../../../assets/images/apps/GooglePlayAppLogo.svg';
import { ReactComponent as AppStoreAppLogo } from '../../../../assets/images/apps/AppStoreAppLogo.svg';

interface AppItemProps {
  title: string;
  googleLink: string;
  appleLink: string;
  icon: React.ReactElement;
}

export const AppItem: FC<AppItemProps> = ({ title, googleLink, appleLink, icon }) => {
  return (
    <div className="app-item">
      {icon}
      <div className="app-item__buttons-container">
        <article className="app-item__buttons-container__title">{title}</article>
        <div className="app-item__buttons-container__buttons">
          <a href={googleLink} target="_blank" rel="noreferrer">
            <GooglePlayAppLogo />
          </a>
          <a href={appleLink} target="_blank" rel="noreferrer">
            <AppStoreAppLogo />
          </a>
        </div>
      </div>
    </div>
  );
};
